<template>
  <div class="author">
    <NuxtLink
      v-for="author in authors"
      :key="author.uuid"
      :to="`/blog/authors/${author.slug}`"
      class="author__link"
    >
      <BaseNuxtImage
        :class="[
          'author__picture',
          {
            'author__picture--small': isSmall,
          },
        ]"
        :src="src(author)"
        :alt="alt(author)"
        loading="lazy"
      />
    </NuxtLink>
    <span class="author__name paragraph--s">
      {{ nameField }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import type { BlogAuthorStoryblok, Story } from '@/types'

interface Props {
  authors: Story<BlogAuthorStoryblok>[]
  isSmall?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  authors: () => [],
  isSmall: false,
})

const nameField = computed(() => {
  if (props.authors.length > 1) {
    return 'Multiple authors'
  } else if (props.authors.length > 0 && props.authors[0].content) {
    return props.authors[0].content.name
  }

  return ''
})

const src = (author: Story<BlogAuthorStoryblok>) => {
  return author.content?.photo?.filename || ''
}
const alt = (author: Story<BlogAuthorStoryblok>) => {
  return author.content?.photo?.alt || ''
}
</script>

<style lang="scss" scoped>
.author {
  display: flex;
  align-items: center;

  &__name {
    margin: 0 24px 0 12px;
  }

  &__link {
    &:not(:first-child) {
      position: relative;
      right: 8px;
      margin-right: -10px;
    }
  }

  &__picture {
    width: 40px;
    height: 40px;
    border-radius: 20px;

    &--small {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
